import api from './api';
import { clearCurrentUserCache, clearPermissionsCache, setCurrentUserCache, setPermissionsCache } from '../utils/roles';
import { userSettingsService } from './userSettings';

export const authService = {
  async login(email, password, rememberMe = false) {
    const response = await api.post('/auth/login', {
      email: email.trim().toLowerCase(),
      password,
      rememberMe
    }, { skipAuthRedirect: true });
    
    const { user } = response.data;

    // Auth is kept in an HttpOnly cookie; user data is loaded from the backend.
    setCurrentUserCache(user);
    // Drop any settings cached while unauthenticated (or from a previous user)
    // so the first post-login load fetches this user's real settings.
    userSettingsService.clearCache();
    try {
      const { data } = await api.get('/permissions/me');
      if (data?.permissions) {
        setPermissionsCache(data.permissions);
      }
    } catch {
      clearPermissionsCache();
    }
    
    return { user };
  },
  
  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      clearCurrentUserCache();
      clearPermissionsCache();
      userSettingsService.clearCache();
    }
  },
  
  isAuthenticated() {
    return api.get('/auth/me').then(() => true).catch(() => false);
  }
};
